// ─────────────────────────────────────────────────────────────────────────────
// 🚨 WHETHER A NEED IS OPEN — MIRROR OF backend/constants/needStatus.js.
//
// The reasoning lives there. Two questions, named:
//   isOpenNeed          — Doorly is still waiting on it ('responded' IS open)
//   isAwaitingBorrower  — the borrower still owes something ('responded' is not,
//                         and no dismissal ever is)
//   isVisibleToBorrower — what a borrower or partner may see: open, not dismissed
// Denylist: an unknown or missing status is open.
//
// 🚨 'dismissed' IS CLOSED ONLY WITH PROOF. The server sends `dismissal_proven`
// on need rows — true only for a staff dismissal with a reason on record —
// and a row without it, or a bare status string, cannot show the proof and is
// OPEN. backend/test/needStatus.test.js asserts the two files agree and fails if
// a second definition appears.
// ─────────────────────────────────────────────────────────────────────────────

export const CLOSED_NEED_STATUSES = Object.freeze(['resolved', 'accepted', 'completed']);
export const DISMISSED_STATUS = 'dismissed';
export const BORROWER_DONE_STATUSES = Object.freeze(['responded']);

const norm = (s) => String(s == null ? '' : s).trim().toLowerCase();
const rowOf = (x) => (typeof x === 'object' && x !== null ? x : { status: x });

export function isOpenNeed(need) {
  const row = rowOf(need);
  const s = norm(row.status);
  if (CLOSED_NEED_STATUSES.includes(s)) return false;
  if (s === DISMISSED_STATUS) return row.dismissal_proven !== true;
  return true;
}

export function isUnprovenDismissal(need) {
  const row = rowOf(need);
  return norm(row.status) === DISMISSED_STATUS && isOpenNeed(row);
}

// 🚨 NEVER FOR A DISMISSAL. An unproven dismissal is open to staff and the
// gates, and owed by nobody — it must not reach a borrower or partner screen.
export function isAwaitingBorrower(need) {
  const row = rowOf(need);
  const s = norm(row.status);
  return isOpenNeed(row) && !BORROWER_DONE_STATUSES.includes(s) && s !== DISMISSED_STATUS;
}

/** Answered, with Doorly to judge it — the "in review" badge. */
export function isAwaitingReview(need) {
  const row = rowOf(need);
  return isOpenNeed(row) && BORROWER_DONE_STATUSES.includes(norm(row.status));
}

/** What a borrower or partner may see: open and not dismissed. */
export function isVisibleToBorrower(need) {
  const row = rowOf(need);
  return isOpenNeed(row) && norm(row.status) !== DISMISSED_STATUS;
}
